"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAny = exports.createSingleton = void 0;
function createSingleton(instance) {
    if (!window.tdocsNetcheck) {
        // 如果 window 上没有全局 DocsNetcheck, 则初始化单例
        window.tdocsNetcheck = instance;
        window.tdocsNetcheck.init();
    }
    else {
        // 新版本覆盖旧版本,并且继承原有的回调函数
        var version = window.tdocsNetcheck.getVersion();
        if (instance.getVersion() > version) {
            instance.extendCallbacks(window.tdocsNetcheck.getCallbacks());
            window.tdocsNetcheck.destory();
            window.tdocsNetcheck = instance;
            window.tdocsNetcheck.init();
        }
    }
    // window 上的tdocsNetcheck是全局单例,最终以这个为准;
    return window.tdocsNetcheck;
}
exports.createSingleton = createSingleton;
// Promise.any polyfill
var promiseAny = function (promises) { return new Promise(function (resolve, reject) {
    var length = promises.length;
    if (!length)
        reject(new AggregateError('null'));
    var errors = [];
    promises.forEach(function (promise) {
        promise
            .then(function (value) { return resolve(value); })
            .catch(function (error) {
            length -= 1;
            errors.push(error);
            if (!length)
                reject(new AggregateError(errors));
        });
    });
}); };
exports.promiseAny = promiseAny;
//# sourceMappingURL=helper.js.map